import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgArrowDown(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.2498 24.9824V2.75H14.7498V24.9825L7.9997 18.2324L6.23193 20.0002L15.1158 28.8841C15.3502 29.1185 15.6682 29.2502 15.9997 29.2502C16.3312 29.2502 16.6492 29.1185 16.8836 28.8841L25.7675 20.0002L23.9997 18.2324L17.2498 24.9824Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
